import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
  Card,
  Dropdown} from 'react-bootstrap'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsEyeFill,
  BsSearch,
  BsArrowClockwise,
  BsThreeDotsVertical,
  BsBookFill,
  BsFileEarmarkSpreadsheetFill,
  BsFileEarmarkPdfFill,
  BsCalendar3} from 'react-icons/bs'
import {
  LuGraduationCap} from 'react-icons/lu'
import ApiEndpoints,{BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditStudentModal from './EditStudentModal'
import { useLocation, useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'

const DataTable = () => {
  const {token, logout} = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [searchAdmissionDate, setSearchAdmissionDate] = useState("")

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const initialData = []

  const [data, setData] = useState(initialData)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [showModal, setShowModal] = useState(false)
  const [filteredData, setFilteredData] = useState([]) // Data displayed after filtering
  const [loading, setLoading] = useState(false)
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [students, setStudents] = useState([])
  const [selectedClass, setSelectedClass] = useState('')
  const location = useLocation()

  useEffect(() => {
    if (location.state?.newStudent) {
      setNewStudent(location.state.newStudent)
      setStudentImage(location.state.studentImage || null)

      // Clear state after using it, so it's not retained on refresh
      navigate(location.pathname, { replace: true }) // removes location.state
    }
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        console.log("userCookie",user)
        setUserRole(user)
        token = user.token
        console.log('TOKEN:', token)
        setUser(JSON.parse(userCookie))
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId)}

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/students/passed-out',
          { headers },
        )

        console.log('Passed Out Students response: ', response.data.students)
        const passedOutStudents = response.data.students || []
        setStudents(passedOutStudents)
        setData(passedOutStudents)
        setFilteredData(passedOutStudents)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
        setStudents([])
        setData([])
        setFilteredData([])
      }
    }

    fetchFilteredData()
  }, [loading])

  const [selectedData, setSelectedData] = useState({})
  const fetchFilteredData = ({
    course,
    class: classId,
    student,
    admission_date}) => {
    console.log('COURSE:', course)
    console.log('class:', classId)
    console.log('student:', student)
    console.log('admission_date:', admission_date)
    
    // If no filters are applied, reset to all students
    if (!admission_date && !student && !course && !classId) {
      setData(students)
      return
    }
    
    if (admission_date) {
      const selectedDate = new Date(admission_date).toISOString().split('T')[0]
      const filtered = students.filter((s) => {
        const studentDate = new Date(s.admission_date)
          .toISOString()
          .split('T')[0]
        return studentDate === selectedDate
      })
      setData(filtered)
    }

    if (student) {
      console.log('STUDENT AFTER SELECT:', student)
      const studentName = students.find((s) => s.id === Number(student))
      let filtered = [...students]

      console.log('STUDENT NAME:', studentName)
      if (studentName) {
        setData([studentName])
      }

      const isNumeric = /^\d+$/.test(student) // Check if input is number (ID)

      if (isNumeric) {
        console.log('Filtering by student ID')
        filtered = filtered.filter((s) => s.id === Number(student))
      } else {
        console.log('Filtering by student NAME')
        filtered = filtered.filter((s) =>
          s.name?.toLowerCase().includes(student.toLowerCase()),
        )
      }
      console.log('Filtered Students:', filtered)
      setData(filtered)
    }
  }

  useEffect(() => {
    let filteredStu = students
    console.log('🔵 Filtered Students:', filteredStu)

    if (selectedClass) {
      const instituteId = Cookies.get('institute_id')

      const headers = {
        'institute-Id': Number(instituteId),
        Authorization: user?.token ? `Bearer ${user.token}` : undefined}

      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${selectedClass}`,
          { headers },
        )
        .then((res) => {
          const classStudents = res.data.data || []
          console.log('Fetched Students by class:', classStudents)

          const classStudentIds = new Set(classStudents.map((stu) => stu.id))
          const filteredData = students.filter((student) =>
            classStudentIds.has(student.id),
          )

          console.log('✅ Filtered Data to Display:', filteredData)
          setFilteredData(filteredData)
          setData(filteredData) // for table
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setFilteredData([])

          // setFilteredStudents([])
          setClasses([])
        })
    }
  }, [students, selectedClass])

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [selectedData])

  // Filter filteredData based on search inputs
  useEffect(() => {
    let filtered = data;

    if (search.trim() !== "") {
      filtered = filtered.filter((st) =>
        st.name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (searchAdmissionDate.trim() !== "") {
      const selectedDate = new Date(searchAdmissionDate).toISOString().split('T')[0]
      filtered = filtered.filter((st) => {
        const studentDate = new Date(st.admission_date)
          .toISOString()
          .split('T')[0]
        return studentDate === selectedDate
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  }, [search, searchAdmissionDate, data]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, itemsPerPage, totalPages])

  const [newStudent, setNewStudent] = useState({
    name: '',
    dob: '',
    age: '',
    gender: '',
    father_name: '',
    mother_name: '',
    admission_date: '',
    admission_number: '',
    course_id: '',
    class_id: '',
    id_proof_number: '',
    id_proof_type: '',
    phone: '',
    whatsapp_number: '',
    parents_number: '',
    email: '',
    address: '',
    institute_id: ''})

  const [studentImage, setStudentImage] = useState(null)
  const [courseTouched, setCourseTouched] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [selectedNewCourse, setSelectedNewCourse] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllInstitutes().then((res) => setInstitutes(res.data.data))
  }, [])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setNewStudent((prev) => ({ ...prev, course_id: courseId }))
    // setClasses([])
    setStudentCount(null)
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
            setStudentCount(null)
          } else {
            console.error('Error fetching classes:', error)
            toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
          setStudentCount(null)
        })
    }
  }
  const handleNavigateToCreateClass = () => {
    navigate('/AddClass', {
      state: {
        from: 'AddStudent',
        newStudent,
        studentImage,
        selectedNewCourse}})
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    setNewStudent((prev) => ({ ...prev, class_id: classId }))

    // Clear previous student count
    setStudentCount(null)
    setCountColor('')

    if (classId) {
      // Call the API to get the student count for the selected class
      fetch(
        BASE_URL+`/get/class/student/count?class_id=${classId}`,{
        headers :
          {
          Authorization: `Bearer ${token}`
        }
      } 
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data?.status &&
            data?.data?.current !== undefined &&
            data?.data?.maximum_limit !== undefined
          ) {
            const current = data.data.current === null ? 0 : data.data.current // Treat null as 0
            const maximum_limit = parseInt(data.data.maximum_limit, 10) // Parse maximum_limit as a number
            setStudentCount({ current, maximum_limit }) // Set the state with correct property names
            setCountColor('green') // Example color for success
          } else {
            setStudentCount('No data available')
            setCountColor('red') // Example color for no data
          }
        })
        .catch((error) => {
          console.error('Error fetching student count:', error)
          setStudentCount('Error fetching data')
          setCountColor('red') // Example color for error
        })
    }
  }

  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    // Adjust age if the birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }
  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewStudent((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewStudent((prev) => ({
        ...prev,
        dob: value,
        age: age.toString()}))
    } else {
      setNewStudent((prev) => ({ ...prev, [name]: value }))
    }
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      let imageUrl = null

      if (studentImage) {
        if (studentImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }

        const formData = new FormData()
        formData.append('image', studentImage)
        formData.append('folder', 'student')

        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value)
        }

        const imageResponse = await axios.post(
          BASE_URL+'/upload-image',
          formData,
        )
        imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        console.log('IMGURL', imageUrl)
      }
      const studentData = {
        ...newStudent,
        student_image: imageUrl}
      console.log('Sending data: ', newStudent)
      const response = await ApiEndpoints.addStudent(studentData)
      toast.success(response.data.message)
      // setNewStudent('Response: ', response)

      // Reset the form after submission
      setNewStudent({
        name: '',
        dob: '',
        age: '',
        gender: '',
        father_name: '',
        mother_name: '',
        admission_date: '',
        admission_number: '',
        course_id: '',
        class_id: '',
        id_proof_type: '',
        id_proof_number: '',
        phone: '',
        whatsapp_number: '',
        parents_number: '',
        email: '',
        address: '',
        institute_id: ''})
      setStudentImage(null)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something wents wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleView = (id) => {
    if (!id) {
      console.error('Student ID is undefined')
      return
    }
    console.log('Navigate to : ', `/student/profile/${id}`)
    navigate(`/student/profile/${id}`, {
      state: {
        fromPassedOutStudents: true
      }
    })
  }

  const handleEnrolledCourses = (id) => {
    if (!id) {
      console.error('Student id is undefined')
      return
    }

    const student = filteredData.find((item) => item.id === id)
    const studentName = student?.name
    const courseName =
      courses.find((course) => course.id === student?.course_id)?.name || 'N/A'
    const className =
      classes.find((cls) => cls.id === student?.class_id)?.class_name || 'N/A'

    console.log('Navigate to:', `/student/enrolled-courses/${id}`)
    console.log('Student Name:', studentName)
    console.log('Student ID:', id)
    console.log('Course Name:', courseName)
    console.log('Class Name:', className)
    console.log('Admission Number:', student?.admission_number)

    navigate(`/student/enrolled-courses/${id}`, {
      state: {
        student_name: studentName,
        student_id: id,
        course_name: courseName,
        class_name: className,
        admission_number: student?.admission_number}})
  }

  const handleUpdate = (data) => {
    console.log('Data:', data)
    navigate(`/student/update-profile/${data.id}`, {
      state: {
        data,
        status: data.status.charAt(0).toUpperCase() + data.status.slice(1)}})
    console.log('Data:', data)
  }
  const getPassedOutExportRows = () =>
    filteredData.map((student) => ({
      'Admission Number': student.admission_number,
      Name: student.name,
      'Father Name': student.father_name,
      'Admission Date': student.admission_date,
      Course: courses.find((c) => c.id === student.course_id)?.name || 'N/A',
      Class:
        classes.find((c) => c.id === student.class_id)?.class_name || 'N/A',
      'Parent Number': student.parents_number}))

  const exportToExcel = () => {
    const exportData = getPassedOutExportRows()

    const worksheet = XLSX.utils.json_to_sheet(exportData)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students')

    XLSX.writeFile(workbook, 'Student_Records.xlsx')
  }

  const handleSaveAsPDF = () => {
    const exportData = getPassedOutExportRows()
    if (exportData.length === 0) return

    try {
      const doc = new jsPDF('l', 'mm', 'a4')
      const pageWidth = doc.internal.pageSize.getWidth()
      const pageHeight = doc.internal.pageSize.getHeight()
      const margin = 10
      const rowHeight = 8
      let yPos = 22

      const headers = [
        'Adm. No.',
        'Name',
        'Father',
        'Adm. Date',
        'Course',
        'Class',
        'Parent No.',
      ]

      const colWidths = [26, 34, 30, 28, 40, 28, 34]

      const drawTableHeader = () => {
        let xPos = margin
        doc.setFillColor(34, 56, 67)
        doc.rect(margin, yPos, pageWidth - margin * 2, rowHeight, 'F')
        doc.setTextColor(255, 255, 255)
        doc.setFontSize(8)
        doc.setFont('helvetica', 'bold')
        headers.forEach((header, index) => {
          doc.text(header, xPos + 1.5, yPos + 5.5)
          xPos += colWidths[index]
        })
        yPos += rowHeight
      }

      const fitText = (text, maxLength = 18) => {
        const safeText = String(text || '')
        if (safeText.length <= maxLength) return safeText
        return `${safeText.slice(0, maxLength - 3)}...`
      }

      const instituteDisplayName = String(
        name || Cookies.get('name') || Cookies.get('institute_name') || '',
      ).trim()

      doc.setFontSize(14)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(34, 56, 67)
      doc.text(instituteDisplayName || 'Institute', pageWidth / 2, 10, {
        align: 'center'})

      doc.setFontSize(12)
      doc.text('Passed Out Students', pageWidth / 2, 16, {
        align: 'center'})

      drawTableHeader()

      doc.setFont('helvetica', 'normal')
      doc.setTextColor(17, 24, 39)
      doc.setFontSize(7.5)

      exportData.forEach((rowObj, index) => {
        if (yPos + rowHeight > pageHeight - margin) {
          doc.addPage()
          yPos = 14
          drawTableHeader()
          doc.setFont('helvetica', 'normal')
          doc.setTextColor(17, 24, 39)
          doc.setFontSize(7.5)
        }

        let xPos = margin
        const admDate = rowObj['Admission Date']
        const admDateStr = admDate
          ? (() => {
              try {
                return new Date(admDate).toLocaleDateString('en-GB')
              } catch {
                return String(admDate)
              }
            })()
          : 'N/A'

        const rowData = [
          fitText(rowObj['Admission Number'], 11),
          fitText(rowObj.Name, 18),
          fitText(rowObj['Father Name'], 16),
          admDateStr,
          fitText(rowObj.Course, 22),
          fitText(rowObj.Class, 14),
          fitText(rowObj['Parent Number'], 14),
        ]

        if (index % 2 !== 0) {
          doc.setFillColor(249, 250, 251)
          doc.rect(margin, yPos, pageWidth - margin * 2, rowHeight, 'F')
        }

        rowData.forEach((cell, colIndex) => {
          doc.text(String(cell), xPos + 1.5, yPos + 5.5)
          xPos += colWidths[colIndex]
        })

        yPos += rowHeight
      })

      doc.save('Passed_Out_Student_Records.pdf')
    } catch (error) {
      console.error('Error while generating PDF:', error)
    }
  }
  // const handleRefresh = () => {
  //   setSelectedData({})
  //   setFilteredData(data) // Reset to original data
  //   setSearchAdmissionDate({})
  //   setSearch('')
  //   setSelectedClass(null)
  //   setData(students)
  //   setResetKey((prev) => prev + 1)
  // }
  const handleRefresh = () => {
    setSelectedData({}) // clears selected course/class/student
    setSearchAdmissionDate('')
    setFilteredData(students)
    setSearch('')
    setData(students) // or original unfiltered data
    setCurrentPage(1)
  }

  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }

          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          /* Fix dropdown menu positioning and z-index - ensure it appears above table container */
          .dropdown-menu {
            z-index: 1050 !important;
            position: absolute !important;
          }

          /* Ensure table container allows dropdown overflow but prevents scrolling */
          .table-container {
            overflow-x: auto;
            overflow-y: visible !important;
            position: relative;
          }

          /* Ensure dropdown wrapper has proper z-index */
          .dropdown-wrapper {
            position: relative;
            z-index: 9999 !important;
          }

          /* Ensure Card allows dropdown to overflow */
          .table-card {
            overflow: visible !important;
          }

          /* Table wrapper inside card - allows dropdown to escape */
          .table-wrapper {
            overflow-x: auto;
            overflow-y: visible !important;
            max-height: none !important;
            position: relative;
          }

          /* Ensure dropdown menu renders outside container */
          .dropdown-menu.show {
            z-index: 1050 !important;
            position: absolute !important;
          }

          /* Prevent table from clipping dropdown */
          .table {
            overflow: visible !important;
          }

          /* Ensure dropdown toggle button container allows overflow */
          .table td {
            position: relative;
            overflow: visible !important;
          }

          /* Bootstrap dropdown popper container - ensure it's not clipped */
          .dropdown-menu[data-popper-placement] {
            z-index: 1050 !important;
            position: absolute !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Passed Out Students
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown - Desktop only, hidden on mobile */}
            {!isMobile && (
              <ProfileDropdown logout={logout} showNotifications={true} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="100">100 per page</option>
                  <option value="200">200 per page</option>
                  <option value="300">300 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>
            {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  onClick={handleSaveAsPDF}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: '#EF4444',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#DC2626'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#EF4444'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Save as PDF"
                >
                  <BsFileEarmarkPdfFill size={20} />
                </button>
                <button
                  type="button"
                  onClick={exportToExcel}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: '#10B981',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#059669'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#10B981'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Export to Excel"
                >
                  <BsFileEarmarkSpreadsheetFill size={20} />
                </button>
              </div>
            )}
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Students
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find students quickly with advanced filters
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-4 text-start">
                    {/* Filter by Student Name & Admission Date */}
                    <Col xs={12}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Student Name & Admission Date
                          </label>
                        </div>
                        <Row className="g-3">
                          {/* Search Student Name */}
                          <Col xs={12} md={6}>
                            <div style={{ position: 'relative' }}>
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Search Student Name
                              </label>
                              <div style={{ position: 'relative' }}>
                                <BsSearch 
                                  style={{ 
                                    position: 'absolute', 
                                    left: '12px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)',
                                    color: '#6b7280',
                                    fontSize: '16px',
                                    zIndex: 1}} 
                                />
                                <Form.Control
                                  type="text"
                                  value={search}
                                  onChange={(e) => {
                                    const value = e.target.value
                                    setSearch(value)
                                  }}
                                  placeholder="Enter student name..."
                                  style={{
                                    paddingLeft: '40px',
                                    borderRadius: '8px',
                                    border: '1px solid #D1D3D4',
                                    fontSize: '14px',
                                    height: '40px',
                                    transition: 'all 0.2s ease',
                                    backgroundColor: '#ffffff',
                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#223843'
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#D1D3D4'
                                  }}
                                />
                              </div>
                            </div>
                          </Col>

                          {/* Search by Admission Date */}
                          <Col xs={12} md={6}>
                            <div style={{ position: 'relative' }}>
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Search by Admission Date
                              </label>
                              <div style={{ position: 'relative' }}>
                                <BsCalendar3 
                                  style={{ 
                                    position: 'absolute', 
                                    left: '12px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)',
                                    color: '#6b7280',
                                    fontSize: '16px',
                                    zIndex: 1,
                                    pointerEvents: 'none'
                                  }} 
                                />
                                <Form.Control
                                  type="date"
                                  value={searchAdmissionDate}
                                  onChange={(e) => {
                                    setSearchAdmissionDate(e.target.value)
                                  }}
                                  placeholder="Select admission date"
                                  style={{
                                    paddingLeft: '40px',
                                    borderRadius: '8px',
                                    border: '1px solid #D1D3D4',
                                    fontSize: '14px',
                                    height: '40px',
                                    transition: 'all 0.2s ease',
                                    backgroundColor: '#ffffff',
                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#223843'
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#D1D3D4'
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'visible', backgroundColor: '#ffffff', position: 'relative' }}>
          <div className="table-wrapper" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative', marginBottom: '0' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Admission Number</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Father's Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Admission Date</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Parent's Number</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems
                  .sort(
                    (a, b) =>
                      new Date(b.admission_date) - new Date(a.admission_date),
                  )
                  .map((item, index) => (
                    <Tr 
                      key={index}
                      style={{ 
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #D1D3D4'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#F3F4F6'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                      }}
                    >
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.admission_number}</Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.name}</Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.father_name}</Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                        {item.admission_date
                          ? new Date(item.admission_date).toLocaleDateString(
                              'en-GB',
                              {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric'},
                            )
                          : 'N/A'}
                      </Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.parents_number || 'N/A'}</Td>
                      <Td className="text-center" style={{ padding: '16px', border: 'none', position: 'relative' }}>
                        {/* Desktop View - Dropdown */}
                        <div className="d-none d-md-block">
                          <Dropdown
                            popperConfig={{
                              modifiers: [
                                {
                                  name: 'preventOverflow',
                                  options: {
                                    boundary: 'clippingParents',
                                    padding: 8}},
                                {
                                  name: 'flip',
                                  options: {
                                    fallbackPlacements: ['top', 'bottom', 'left', 'right'],
                                    boundary: 'clippingParents',
                                    padding: 8}},
                                {
                                  name: 'offset',
                                  options: {
                                    offset: [0, 8]}},
                              ],
                              strategy: 'absolute'}}
                          >
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-${item.id}`}
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #D1D3D4',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'}}
                              className="dropdown-toggle-no-caret"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.borderColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.borderColor = '#D1D3D4'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsThreeDotsVertical style={{ color: 'inherit' }} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '8px',
                                minWidth: '180px'}}
                            >
                              {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                                <Dropdown.Item
                                  onClick={() => handleView(item.id)}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s ease',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#223843'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsEyeFill size={18} /> See Profile
                                </Dropdown.Item>
                              )}

                              <Dropdown.Item
                                onClick={() => handleEnrolledCourses(item.id)}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsBookFill size={18} /> Enrolled Courses
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* Mobile View - Circular Buttons in Single Line */}
                        <div className="d-md-none d-flex justify-content-start gap-2">
                          {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                            <button
                              onClick={() => handleView(item.id)}
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#223843',
                                border: 'none',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease',
                                cursor: 'pointer'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1.1)'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                              title="See Profile"
                            >
                              <BsEyeFill size={16} />
                            </button>
                          )}
                          <button
                            onClick={() => handleEnrolledCourses(item.id)}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Enrolled Courses"
                          >
                            <BsBookFill size={16} />
                          </button>
                        </div>
                      </Td>
                    </Tr>
                  ))
              ) : (
                <Tr>
                  <Td colSpan="6" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="students"
        />
        </div>

        {/* Add Student Modal */}
        <Modal
          size="xl"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
            <Modal.Title>Add New Student</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* Personal Details */}

              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={newStudent.name}
                  onChange={handleInputChange}
                  placeholder="Enter Student Name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Date of Birth *</Form.Label>
                <Form.Control
                  type="date"
                  name="dob"
                  value={newStudent.dob}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  type="text"
                  name="age"
                  value={newStudent.age}
                  disabled
                  className="p-2 border rounded bg-light"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Gender *</Form.Label>
                <Form.Select
                  name="gender"
                  value={newStudent.gender}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Father's Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="father_name"
                  value={newStudent.father_name}
                  onChange={handleInputChange}
                  placeholder="Enter Father's Name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mother's Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="mother_name"
                  value={newStudent.mother_name}
                  onChange={handleInputChange}
                  placeholder="Enter Mother's Name"
                />
              </Form.Group>

              {/* Admission Details */}

              <Form.Group className="mb-3">
                <Form.Label>Admission Date *</Form.Label>
                <Form.Control
                  type="date"
                  name="admission_date"
                  value={newStudent.admission_date}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Admission Number *</Form.Label>
                <Form.Control
                  type="text"
                  name="admission_number"
                  value={newStudent.admission_number}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              {/* Course & Schedule */}

              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <Form.Select
                  name="class_id"
                  value={newStudent.class_id}
                  onChange={handleClassChange}
                  disabled={!courseTouched || classes.length === 0}
                >
                  <option value="">Select Class</option>
                  {classes.map((clas) => (
                    <option key={clas.id} value={clas.id}>
                      {clas.class_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px'}}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <FormGroup className="mb-3">
                <FormLabel>Institute *</FormLabel>
                <FormSelect
                  name="institute_id"
                  value={newStudent.institute_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Institute</option>
                  {institutes.map((institute) => (
                    <option key={institute.id} value={institute.institute_id}>
                      {institute.name}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>

              <Form.Group className="mb-3">
                <Form.Label>ID Type</Form.Label>
                <Form.Select
                  name="id_proof_type"
                  value={newStudent.id_proof_type}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="aadhar card">Aadhaar</option>
                  <option value="voter card">Voter ID</option>
                  <option value="license">License</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>ID Proof Number</Form.Label>
                <Form.Control
                  type="number"
                  name="id_proof_number"
                  value={newStudent.id_proof_number}
                  onChange={handleInputChange}
                  placeholder="Enter Roll Number"
                />
              </Form.Group>

              {/* Contact Details */}

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={newStudent.phone}
                  onChange={handleInputChange}
                  placeholder="Enter Phone Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>WhatsApp Number (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="whatsapp_number"
                  value={newStudent.whatsapp_number}
                  onChange={handleInputChange}
                  placeholder="Enter WhatsApp Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Parent's Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="parents_number"
                  value={newStudent.parents_number}
                  onChange={handleInputChange}
                  placeholder="Enter Parent's Phone Number"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={newStudent.email}
                  onChange={handleInputChange}
                  placeholder="Enter Email"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address *</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={newStudent.address}
                  onChange={handleInputChange}
                  placeholder="Enter Address"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Student Image (PNG/JPG/JPEG)</Form.Label>

                <div className="d-flex align-items-center gap-3 mt-2 mb-2">
                  <Form.Control
                    type="file"
                    accept="student_image/png, student_image/jpeg, student_image/jpg"
                    onChange={(e) => setStudentImage(e.target.files[0])}
                    style={{ maxWidth: '700px' }}
                  />
                  {studentImage && (
                    <img
                      src={URL.createObjectURL(studentImage)}
                      alt="Preview"
                      style={{
                        width: 100,
                        height: 100,
                        objectFit: 'cover',
                        borderRadius: 8,
                        border: '1px solid #ccc'}}
                    />
                  )}
                </div>
              </Form.Group>
              <Modal.Footer className="mb-4">
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button variant="success" type="submit">
                  Save Student
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <EditStudentModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          studentData={selectedCourse}
        />
      </div>
    </>
  )
}

export default DataTable
